module.exports = __webpack_public_path__ + "static/pic20-5174e190101e900653ca51048588c1bb.jpg";